// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./icons/trash-can-outline.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./icons/square-edit-outline.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./icons/menu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./icons/close.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

.icon-container {
  display: inline-block;
  width: 25px;
  height: 25px;
}

img {
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
}

html,
body {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

html {
  box-sizing: inherit;
  font-size: 10px;
}

body {
  font-size: 1.6rem;
  background-color: #eeeeee;
  font-family: Arial, Helvetica, sans-serif;
}

#container {
  display: grid;
  grid-template-columns: 250px 1fr;
  grid-template-rows: 80px 1fr;
  height: 100%;
}

.main-header {
  grid-column: 1 / -1;
  background-color: #c38d9e;
  color: white;
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 0 24px;
}

header .logo {
  font-size: 4.5rem;
  letter-spacing: 1.85px;
  display: flex;
  gap: 1.2rem;
}

nav {
  grid-row: 2 / -1;
  background-color: #ffffff;
  position: relative;
}

nav > div {
  margin: 6px 0;
}

nav h1 {
  color: rgba(0, 0, 0, 0.459);
  font-size: 1.56rem;
  margin: 6px;
  letter-spacing: 0.12rem;
}

nav button {
  outline: none;
  border: none;
  cursor: pointer;
  background-color: transparent;
  padding: 10px 20px;
  width: 100%;
  transition: all 0.06s ease-in-out;
}

nav .filters {
  margin: 6px 12px;
}

nav .filters button {
  display: flex;
  align-items: center;
  gap: 14px;
}

nav .filters button:hover {
  transform: translateX(15px);
  background-color: rgba(238, 238, 238, 0.549);
}

nav .filters button:active {
  background-color: #eeeeee;
}

nav .filters button.active {
  transform: translateX(15px);
  background-color: #eeeeee;
  border-left: 3px solid black;
  padding-left: 17px;
}
nav .hr {
  display: inline-block;
  height: 2.459px;
  background-color: #eeeeee;
  width: 100%;
  margin: 20px 0 14px 0;
}

nav .lists {
  position: relative;
  margin: 6px 12px;
  max-height: 230px;
  display: flex;
  flex-flow: column nowrap;
  gap: 8px;
}

nav .list-items {
  max-height: 195px;
  overflow-y: auto;
  list-style-type: none;
}

nav .list-item {
  padding: 12px;
  cursor: pointer;
  width: 100%;
}

nav .lists button,
.list-item {
  display: flex;
}

nav .lists .list-item:hover {
  background-color: rgba(237, 237, 237, 0.4);
}

nav .lists .list-item:active {
  background-color: rgba(238, 238, 238, 0.549);
}

nav .lists button.active {
  background-color: #eeeeee;
  border-left: 3px solid black;
  padding-left: 17px;
}

nav .lists .list-item {
  height: 40px;
  font-size: 1.75rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 210px;
  align-items: center;
  display: flex;
  gap: 12px;
}

nav .lists .list-item.active {
  border-left: 3px inset black;
  background-color: #eeeeee;
}

nav .lists .list-icon {
  flex-shrink: 0;
}

nav .lists .text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

nav .lists .create-list-item {
  font-size: 1.35rem;
  background-color: #c38d9e;
  color: white;
  font-weight: bolder;
  letter-spacing: 0.1rem;
  align-items: center;
  justify-content: center;
  border-width: 2px;
  border-style: solid;
}

nav .lists .create-list-item:hover {
  opacity: 0.85;
}

nav .lists .create-list-item:active {
  background-color: #ffffff;
  border-color: #c38d9e;
  color: #c38d9e;
}

.current-screen,
.empty-screen {
  grid-column: 2 / -1;
  grid-row: 2 / -1;
  margin: 20px;
  padding: 12px;
  background-color: #ffffff;
  border-radius: 9px;
  position: relative;
}

.current-screen .list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  margin: 4px;
}

.current-screen .current-screen-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 250px;
}

.current-screen .options {
  display: flex;
  gap: 25px;
  padding: 8px;
}

.current-screen .options button {
  outline: none;
  border: 1.5px solid white;
  padding: 12px;
  height: 26px;
  width: 52px;
}

.current-screen .options button:active {
  background-color: #ccc;
}

.current-screen .delete-list {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
}

.current-screen .rename-list {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: center;
}

.current-screen .todo-items {
  list-style-type: none;
  display: grid;
  gap: 10px;
  max-height: 380px;
  overflow-y: auto;
}

.todo-item {
  display: flex;
  background-color: #eee;
  height: 60px;
  border-radius: 9px 0px 0px 9px;
  border-right-style: inset;
  border-right-width: 6px;
}

.todo-item[data-priority="high"] {
  border-right-color: rgb(255, 0, 0);
}
.todo-item[data-priority="medium"] {
  border-right-color: rgb(223, 223, 11);
}
.todo-item[data-priority="low"] {
  border-right-color: rgb(89, 84, 84);
}

.todo-item[data-priority="none"] {
  border-right: solid;
  border-radius: 9px;
  border-right-color: #eee;
}

.todo-item .marker-label-container {
  position: relative;
  width: 50px;
  -webkit-tap-highlight-color: transparent;

}

.todo-item .marker-container {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  font-size: 22px;
  user-select: none;
  width: 25px;
  height: 25px;
  -webkit-tap-highlight-color: transparent;

}

.todo-item .marker-container input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  -webkit-tap-highlight-color: transparent;

}

.todo-item .marker {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 25px;
  width: 25px;
  border-radius: 50%;
  background-color: #ffffff;
  border: 2px solid #888;
  -webkit-tap-highlight-color: transparent;
}

.todo-item .marker-container:hover input ~ .marker {
  background-color: #ccc;
}

.todo-item .marker-container input:checked ~ .marker {
  background-color: green;
  border-color: green;
}

.todo-item .marker-container .marker::after {
  content: "";
  position: absolute;
  display: none;
}

.todo-item .marker-container input:checked ~ .marker::after {
  display: block;
}

.todo-item .marker-container .marker::after {
  left: 7.7px;
  top: 3.2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.todo-item .todo-details-overview {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  padding-left: 8px;
  user-select: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.todo-item .todo-details-overview:hover {
  background-color: rgba(182, 175, 175, 0.567);
}

.todo-item .todo-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.todo-item .date-subtask-view {
  font-size: 0.8em;
  display: flex;
  align-items: center;
  gap: 8px;
}

.todo-item > button {
  padding: 9px 12px;
  cursor: pointer;
  align-self: center;
  margin: 8px;
  background-position: center;
  background-repeat: no-repeat;
}

.todo-item .delete-todo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.todo-item .edit-todo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.todo-item .priority {
  width: 12px;
  background-color: red;
  border-top-right-radius: 9px;
  border-bottom-right-radius: 9px;
}

.current-screen .add-task {
  position: absolute;
  bottom: 8px;
  right: 18px;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  border: 2px solid #c38d9e;
  background-color: #c38d9e;
  color: white;
  padding: 8px;
  font-weight: bold;
}

.current-screen .add-task:hover {
  background-color: rgba(195, 141, 158, 0.567);
  border-color: rgba(195, 141, 158, 0.567);
}

.add-task:active path {
  fill: #c38d9e;
}

.current-screen .add-task:active {
  color: #c38d9e;
  background-color: white;
}

dialog {
  margin: auto;
  border: 2px inset;
}

dialog.list-delete-confirm,
dialog.todo-delete-confirm,
.confirm-changes-discard,
.discard-todo-create {
  width: 300px;
}

.list-delete-confirm .dialog-content,
.confirm-changes-discard .dialog-content,
.discard-todo-create .dialog-content,
.create-list-item-dialog form,
.todo-delete-confirm .dialog-content,
.rename-list-item-dialog form,
.todo-details .dialog-content {
  display: flex;
  gap: 12px;
  flex-flow: column nowrap;
  padding: 8px 12px;
  width: 100%;
}

.list-delete-confirm h1,
.create-list-item-dialog h1,
.todo-delete-confirm h1,
.rename-list-item-dialog h1,
.confirm-changes-discard h1,
.discard-todo-create h1 {
  border-bottom: 1.8px solid gray;
  font-size: 2.2rem;
  padding: 8px 0;
}


.list-delete-confirm .btn-group,
.create-list-item-dialog .btn-group,
.todo-delete-confirm .btn-group,
.rename-list-item-dialog .btn-group,
.todo-details .btn-group,
.confirm-changes-discard .btn-group,
.discard-todo-create .btn-group {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.list-delete-confirm button,
.create-list-item-dialog button,
.todo-delete-confirm button,
.rename-list-item-dialog button,
.todo-details button,
.confirm-changes-discard button,
.discard-todo-create button,
.nav .open-nav {
  border: 1px solid gray;
  padding: 8px 12px;
}

.create-list-item-dialog,
.rename-list-item-dialog {
  width: 350px;
  height: 200px;
}

.create-list-item-dialog form,
.rename-list-item-dialog form {
  width: 100%;
  display: flex;
  height: 100%;
}

.create-list-item-dialog h1,
.rename-list-item-dialog h1 {
  font-size: 2.2rem;
  border-bottom: 1.2px solid gray;
}

.create-list-item-dialog input,
.rename-list-item-dialog input {
  margin: auto 0px;
  height: 35px;
  border: none;
  border-bottom: 2px solid;
  padding-left: 10px;
  outline: none;
  font-weight: bold;
  font-size: 1.9rem;
}

.create-todo-item form,
.edit-todo-item form {
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 300px;
}

.create-todo-item .row,
.edit-todo-item .row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.create-todo-item .row-title,
.edit-todo-item .row-title {
  font-size: 1.9rem;
}

.create-todo-item input[type="text"],
.edit-todo-item input[type="text"] {
  height: 30px;
  padding: 6px;
  font-size: 1.5rem;
}

.create-todo-item select,
.edit-todo-item select {
  height: 25px;
}

.create-todo-item textarea,
.edit-todo-item textarea {
  resize: none;
  padding: 6px;
  height: 100px;
}

.create-todo-item .btn-group,
.edit-todo-item .btn-group {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.create-todo-item .btn-group button,
.edit-todo-item .btn-group button {
  padding: 8px 12px;
  border: 1px solid gray;
}

.todo-details .dialog-content {
  max-height: 450px;
  overflow-y: auto;
  max-width: 500px;
  padding: 12px 18px;
  word-break: break-word;
}

.todo-details .dialog-content p {
  display: flex;
}

.todo-details .heading {
  font-weight: bold;
  text-transform: uppercase;
  flex-basis: 95px;
  flex-shrink: 0;
}

.hidden {
  display: none;
}

.separator {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: black;
}

header .open-close-nav {
  display: none;
}

@media screen and (max-width: 800px) {
  #container {
    grid-template-columns: 1fr;
  }

  header .open-close-nav {
    display: inline-block;
    margin-left: auto;
    outline: none;
    border: 1.5px solid white;
    padding: 12px;
    height: 26px;
    width: 52px;
    background-repeat: no-repeat;
    background-position: center;
  }

  header .open-close-nav[data-state="closed"] {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }

  header .open-close-nav[data-state="opened"] {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }

  nav {
    display: none;
    overflow: hidden;
    transition: all 0.04s ease-in-out;
  }

  nav.show {
   display: block;
    width: 100%;
    height: 100%;
    z-index: 1;
    position: absolute;
    top: 86px;
    right: 0;
  }

  nav .lists .list-item {
    width: 100%;
  }

  .current-screen,
  .empty-screen {
    grid-column: 1 / -1;
  }

  .current-screen header {
    padding: 8px 6px;
  }

  .current-screen .current-screen-title {
    font-size: 2.8rem;
  }
}


@media screen and (max-width: 500px) {
  .current-screen .current-screen-title {
    max-width: 135px;
  }

  .current-screen .todo-items {
    max-height: 500px;
  }

  .todo-details .dialog-content {
    width: 300px;
  }
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,wBAAwB;EACxB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yDAAoD;EACpD,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,yDAAsD;EACtD,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,wCAAwC;;AAE1C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,wCAAwC;;AAE1C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;EACR,wCAAwC;;AAE1C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yDAAoD;AACtD;;AAEA;EACE,yDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;;;;;;EAOE,aAAa;EACb,SAAS;EACT,wBAAwB;EACxB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;;;;;EAME,+BAA+B;EAC/B,iBAAiB;EACjB,cAAc;AAChB;;;AAGA;;;;;;;EAOE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;;;;;;;;EAQE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,yDAAuC;EACzC;;EAEA;IACE,yDAAwC;EAC1C;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;GACC,cAAc;IACb,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;;AAGA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n}\n\n.icon-container {\n  display: inline-block;\n  width: 25px;\n  height: 25px;\n}\n\nimg {\n  width: 100%;\n  max-width: 100%;\n  height: 100%;\n  max-height: 100%;\n}\n\nhtml,\nbody {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\nhtml {\n  box-sizing: inherit;\n  font-size: 10px;\n}\n\nbody {\n  font-size: 1.6rem;\n  background-color: #eeeeee;\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n#container {\n  display: grid;\n  grid-template-columns: 250px 1fr;\n  grid-template-rows: 80px 1fr;\n  height: 100%;\n}\n\n.main-header {\n  grid-column: 1 / -1;\n  background-color: #c38d9e;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  padding: 0 24px;\n}\n\nheader .logo {\n  font-size: 4.5rem;\n  letter-spacing: 1.85px;\n  display: flex;\n  gap: 1.2rem;\n}\n\nnav {\n  grid-row: 2 / -1;\n  background-color: #ffffff;\n  position: relative;\n}\n\nnav > div {\n  margin: 6px 0;\n}\n\nnav h1 {\n  color: rgba(0, 0, 0, 0.459);\n  font-size: 1.56rem;\n  margin: 6px;\n  letter-spacing: 0.12rem;\n}\n\nnav button {\n  outline: none;\n  border: none;\n  cursor: pointer;\n  background-color: transparent;\n  padding: 10px 20px;\n  width: 100%;\n  transition: all 0.06s ease-in-out;\n}\n\nnav .filters {\n  margin: 6px 12px;\n}\n\nnav .filters button {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\nnav .filters button:hover {\n  transform: translateX(15px);\n  background-color: rgba(238, 238, 238, 0.549);\n}\n\nnav .filters button:active {\n  background-color: #eeeeee;\n}\n\nnav .filters button.active {\n  transform: translateX(15px);\n  background-color: #eeeeee;\n  border-left: 3px solid black;\n  padding-left: 17px;\n}\nnav .hr {\n  display: inline-block;\n  height: 2.459px;\n  background-color: #eeeeee;\n  width: 100%;\n  margin: 20px 0 14px 0;\n}\n\nnav .lists {\n  position: relative;\n  margin: 6px 12px;\n  max-height: 230px;\n  display: flex;\n  flex-flow: column nowrap;\n  gap: 8px;\n}\n\nnav .list-items {\n  max-height: 195px;\n  overflow-y: auto;\n  list-style-type: none;\n}\n\nnav .list-item {\n  padding: 12px;\n  cursor: pointer;\n  width: 100%;\n}\n\nnav .lists button,\n.list-item {\n  display: flex;\n}\n\nnav .lists .list-item:hover {\n  background-color: rgba(237, 237, 237, 0.4);\n}\n\nnav .lists .list-item:active {\n  background-color: rgba(238, 238, 238, 0.549);\n}\n\nnav .lists button.active {\n  background-color: #eeeeee;\n  border-left: 3px solid black;\n  padding-left: 17px;\n}\n\nnav .lists .list-item {\n  height: 40px;\n  font-size: 1.75rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 210px;\n  align-items: center;\n  display: flex;\n  gap: 12px;\n}\n\nnav .lists .list-item.active {\n  border-left: 3px inset black;\n  background-color: #eeeeee;\n}\n\nnav .lists .list-icon {\n  flex-shrink: 0;\n}\n\nnav .lists .text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\nnav .lists .create-list-item {\n  font-size: 1.35rem;\n  background-color: #c38d9e;\n  color: white;\n  font-weight: bolder;\n  letter-spacing: 0.1rem;\n  align-items: center;\n  justify-content: center;\n  border-width: 2px;\n  border-style: solid;\n}\n\nnav .lists .create-list-item:hover {\n  opacity: 0.85;\n}\n\nnav .lists .create-list-item:active {\n  background-color: #ffffff;\n  border-color: #c38d9e;\n  color: #c38d9e;\n}\n\n.current-screen,\n.empty-screen {\n  grid-column: 2 / -1;\n  grid-row: 2 / -1;\n  margin: 20px;\n  padding: 12px;\n  background-color: #ffffff;\n  border-radius: 9px;\n  position: relative;\n}\n\n.current-screen .list-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px;\n  margin: 4px;\n}\n\n.current-screen .current-screen-title {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 250px;\n}\n\n.current-screen .options {\n  display: flex;\n  gap: 25px;\n  padding: 8px;\n}\n\n.current-screen .options button {\n  outline: none;\n  border: 1.5px solid white;\n  padding: 12px;\n  height: 26px;\n  width: 52px;\n}\n\n.current-screen .options button:active {\n  background-color: #ccc;\n}\n\n.current-screen .delete-list {\n  background-image: url(./icons/trash-can-outline.svg);\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.current-screen .rename-list {\n  background-image: url(./icons/square-edit-outline.svg);\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.current-screen .todo-items {\n  list-style-type: none;\n  display: grid;\n  gap: 10px;\n  max-height: 380px;\n  overflow-y: auto;\n}\n\n.todo-item {\n  display: flex;\n  background-color: #eee;\n  height: 60px;\n  border-radius: 9px 0px 0px 9px;\n  border-right-style: inset;\n  border-right-width: 6px;\n}\n\n.todo-item[data-priority=\"high\"] {\n  border-right-color: rgb(255, 0, 0);\n}\n.todo-item[data-priority=\"medium\"] {\n  border-right-color: rgb(223, 223, 11);\n}\n.todo-item[data-priority=\"low\"] {\n  border-right-color: rgb(89, 84, 84);\n}\n\n.todo-item[data-priority=\"none\"] {\n  border-right: solid;\n  border-radius: 9px;\n  border-right-color: #eee;\n}\n\n.todo-item .marker-label-container {\n  position: relative;\n  width: 50px;\n  -webkit-tap-highlight-color: transparent;\n\n}\n\n.todo-item .marker-container {\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n  font-size: 22px;\n  user-select: none;\n  width: 25px;\n  height: 25px;\n  -webkit-tap-highlight-color: transparent;\n\n}\n\n.todo-item .marker-container input[type=\"checkbox\"] {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n  -webkit-tap-highlight-color: transparent;\n\n}\n\n.todo-item .marker {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  height: 25px;\n  width: 25px;\n  border-radius: 50%;\n  background-color: #ffffff;\n  border: 2px solid #888;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.todo-item .marker-container:hover input ~ .marker {\n  background-color: #ccc;\n}\n\n.todo-item .marker-container input:checked ~ .marker {\n  background-color: green;\n  border-color: green;\n}\n\n.todo-item .marker-container .marker::after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n.todo-item .marker-container input:checked ~ .marker::after {\n  display: block;\n}\n\n.todo-item .marker-container .marker::after {\n  left: 7.7px;\n  top: 3.2px;\n  width: 5px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 3px 3px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.todo-item .todo-details-overview {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 8px;\n  padding-left: 8px;\n  user-select: none;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.todo-item .todo-details-overview:hover {\n  background-color: rgba(182, 175, 175, 0.567);\n}\n\n.todo-item .todo-title {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.todo-item .date-subtask-view {\n  font-size: 0.8em;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.todo-item > button {\n  padding: 9px 12px;\n  cursor: pointer;\n  align-self: center;\n  margin: 8px;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.todo-item .delete-todo {\n  background-image: url(./icons/trash-can-outline.svg);\n}\n\n.todo-item .edit-todo {\n  background-image: url(./icons/square-edit-outline.svg);\n}\n\n.todo-item .priority {\n  width: 12px;\n  background-color: red;\n  border-top-right-radius: 9px;\n  border-bottom-right-radius: 9px;\n}\n\n.current-screen .add-task {\n  position: absolute;\n  bottom: 8px;\n  right: 18px;\n  height: 50px;\n  width: 50px;\n  border-radius: 50%;\n  border: 2px solid #c38d9e;\n  background-color: #c38d9e;\n  color: white;\n  padding: 8px;\n  font-weight: bold;\n}\n\n.current-screen .add-task:hover {\n  background-color: rgba(195, 141, 158, 0.567);\n  border-color: rgba(195, 141, 158, 0.567);\n}\n\n.add-task:active path {\n  fill: #c38d9e;\n}\n\n.current-screen .add-task:active {\n  color: #c38d9e;\n  background-color: white;\n}\n\ndialog {\n  margin: auto;\n  border: 2px inset;\n}\n\ndialog.list-delete-confirm,\ndialog.todo-delete-confirm,\n.confirm-changes-discard,\n.discard-todo-create {\n  width: 300px;\n}\n\n.list-delete-confirm .dialog-content,\n.confirm-changes-discard .dialog-content,\n.discard-todo-create .dialog-content,\n.create-list-item-dialog form,\n.todo-delete-confirm .dialog-content,\n.rename-list-item-dialog form,\n.todo-details .dialog-content {\n  display: flex;\n  gap: 12px;\n  flex-flow: column nowrap;\n  padding: 8px 12px;\n  width: 100%;\n}\n\n.list-delete-confirm h1,\n.create-list-item-dialog h1,\n.todo-delete-confirm h1,\n.rename-list-item-dialog h1,\n.confirm-changes-discard h1,\n.discard-todo-create h1 {\n  border-bottom: 1.8px solid gray;\n  font-size: 2.2rem;\n  padding: 8px 0;\n}\n\n\n.list-delete-confirm .btn-group,\n.create-list-item-dialog .btn-group,\n.todo-delete-confirm .btn-group,\n.rename-list-item-dialog .btn-group,\n.todo-details .btn-group,\n.confirm-changes-discard .btn-group,\n.discard-todo-create .btn-group {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.list-delete-confirm button,\n.create-list-item-dialog button,\n.todo-delete-confirm button,\n.rename-list-item-dialog button,\n.todo-details button,\n.confirm-changes-discard button,\n.discard-todo-create button,\n.nav .open-nav {\n  border: 1px solid gray;\n  padding: 8px 12px;\n}\n\n.create-list-item-dialog,\n.rename-list-item-dialog {\n  width: 350px;\n  height: 200px;\n}\n\n.create-list-item-dialog form,\n.rename-list-item-dialog form {\n  width: 100%;\n  display: flex;\n  height: 100%;\n}\n\n.create-list-item-dialog h1,\n.rename-list-item-dialog h1 {\n  font-size: 2.2rem;\n  border-bottom: 1.2px solid gray;\n}\n\n.create-list-item-dialog input,\n.rename-list-item-dialog input {\n  margin: auto 0px;\n  height: 35px;\n  border: none;\n  border-bottom: 2px solid;\n  padding-left: 10px;\n  outline: none;\n  font-weight: bold;\n  font-size: 1.9rem;\n}\n\n.create-todo-item form,\n.edit-todo-item form {\n  padding: 8px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 300px;\n}\n\n.create-todo-item .row,\n.edit-todo-item .row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.create-todo-item .row-title,\n.edit-todo-item .row-title {\n  font-size: 1.9rem;\n}\n\n.create-todo-item input[type=\"text\"],\n.edit-todo-item input[type=\"text\"] {\n  height: 30px;\n  padding: 6px;\n  font-size: 1.5rem;\n}\n\n.create-todo-item select,\n.edit-todo-item select {\n  height: 25px;\n}\n\n.create-todo-item textarea,\n.edit-todo-item textarea {\n  resize: none;\n  padding: 6px;\n  height: 100px;\n}\n\n.create-todo-item .btn-group,\n.edit-todo-item .btn-group {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.create-todo-item .btn-group button,\n.edit-todo-item .btn-group button {\n  padding: 8px 12px;\n  border: 1px solid gray;\n}\n\n.todo-details .dialog-content {\n  max-height: 450px;\n  overflow-y: auto;\n  max-width: 500px;\n  padding: 12px 18px;\n  word-break: break-word;\n}\n\n.todo-details .dialog-content p {\n  display: flex;\n}\n\n.todo-details .heading {\n  font-weight: bold;\n  text-transform: uppercase;\n  flex-basis: 95px;\n  flex-shrink: 0;\n}\n\n.hidden {\n  display: none;\n}\n\n.separator {\n  display: inline-block;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background-color: black;\n}\n\nheader .open-close-nav {\n  display: none;\n}\n\n@media screen and (max-width: 800px) {\n  #container {\n    grid-template-columns: 1fr;\n  }\n\n  header .open-close-nav {\n    display: inline-block;\n    margin-left: auto;\n    outline: none;\n    border: 1.5px solid white;\n    padding: 12px;\n    height: 26px;\n    width: 52px;\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n\n  header .open-close-nav[data-state=\"closed\"] {\n    background-image: url(./icons/menu.svg);\n  }\n\n  header .open-close-nav[data-state=\"opened\"] {\n    background-image: url(./icons/close.svg);\n  }\n\n  nav {\n    display: none;\n    overflow: hidden;\n    transition: all 0.04s ease-in-out;\n  }\n\n  nav.show {\n   display: block;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    position: absolute;\n    top: 86px;\n    right: 0;\n  }\n\n  nav .lists .list-item {\n    width: 100%;\n  }\n\n  .current-screen,\n  .empty-screen {\n    grid-column: 1 / -1;\n  }\n\n  .current-screen header {\n    padding: 8px 6px;\n  }\n\n  .current-screen .current-screen-title {\n    font-size: 2.8rem;\n  }\n}\n\n\n@media screen and (max-width: 500px) {\n  .current-screen .current-screen-title {\n    max-width: 135px;\n  }\n\n  .current-screen .todo-items {\n    max-height: 500px;\n  }\n\n  .todo-details .dialog-content {\n    width: 300px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
